// extracted by mini-css-extract-plugin
export default {"headers":"Cart_headers__mw1H3","container1":"Cart_container1__lGvGi","card":"Cart_card__Ncurl","imgs":"Cart_imgs__N08TC","pay":"Cart_pay__s9P3t"};